import { useVersionUpdateKind } from 'modules/shares/operations'
import { useToast } from 'containers/ToastManager'
import { useModalContext } from 'containers/ModalManager'
import { UnstarUpdateModal } from '../components/UnstarUpdateModal'

export interface UseVersionUnstarProps {
  versionIdentifier: string
  isLibrary: boolean
}

export const useVersionUnstar = (props: UseVersionUnstarProps) => {
  const { versionIdentifier, ...modalProps } = props
  const { showModal } = useModalContext()
  const { showToast } = useToast()

  const shouldSkipModal: boolean =
    JSON.parse(
      localStorage.getItem('user:preferences:skipUnstarModal') || 'false'
    ) ?? false

  const [versionKindUpdate] = useVersionUpdateKind({
    onCompleted: () => {
      showToast('The Update has been unstarred')
    },
    onError: message => showToast(message, 'negative'),
  })

  if (shouldSkipModal) {
    return [
      () =>
        versionKindUpdate({
          versionIdentifier,
          kind: 'DRAFT',
        }),
    ]
  }

  return [
    () =>
      showModal(UnstarUpdateModal, {
        versionIdentifier: props.versionIdentifier,
        ...modalProps,
      }),
  ]
}
